import './BasePage.scss';

import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { node } from 'prop-types';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';
import { getPathnameEnd } from 'services/Externals';
import { kebabCase } from 'lodash';
import AAMFooterContainer from "../../layouts/Footer/FooterUtil";
const BasePage = ({
  children,
  backLink,
  backLinkText,
  title,
  titleSubText,
  showFooter,
  isLoading,
  isError,
  pageName,
  className,
  isMobileApp,
  footerProductTypes,
  appLoaded,
  isSalesforceRepEnabled
}) => {
  if (isError) {
    return (
      <Redirect
        to={
          window.location
            ? `${getPathnameEnd(window.location.pathname)}/error`
            : '/error'
        }
      />
    );
  }

  if (isLoading) {
    return <PageLoadingSpinner name={`${pageName}...`} />;
  }

  return (
    <div className={className}>
      <div className={`base-page ${kebabCase(pageName)}`}>
        <div className="base-page_header">
          {backLink && (
            <div className="base-page_link">
              <Link className="base-page_link" to={backLink}>
                <Arrow className="base-page_arrow" />
                {backLinkText}
              </Link>
            </div>
          )}
          {title && <div className="base-page_title">{title}</div>}
          {titleSubText && (
            <div className="base-page_title-subtext">{titleSubText}</div>
          )}
        </div>
      </div>
      {children}
      {showFooter && !isSalesforceRepEnabled && (
        <AAMFooterContainer
          isMobileParam={isMobileApp}
          footerProductTypes={footerProductTypes}
          appLoaded={appLoaded}
        />
      )}
    </div>
  );
};

BasePage.propTypes = {
  children: node.isRequired
};

export default BasePage;
